import { Provider } from 'react-redux';
import React, { useState, useEffect} from "react";
import fire from './fire';
import "./App.css";
import Login from './components/Login';
import Intake from './components/Intake'
import store from "./redux/store";

const App = () => {
  const [user, setUser] = useState('');
  const [uid, setUid] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [hasAccount, setHasAccount] = useState(true);
  const [resetPwEmail, setResetPwEmail] = useState('')

  const clearInputs = () =>{
    setEmail('');
    setPassword('');
  }

  const clearErrors = () => {
    setEmailError('');
    setPasswordError('');
  }

  const handleLogin = () =>{
    clearErrors();
    fire
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then((userCredential) => {
      // Signed in 
      setUid(userCredential.user.uid);
      // ...
    })
    .catch(err => {
      switch(err.code){
        case "auth/invalid-email":
        case "auth/user-disabled":
        case "auth/user-not-found":
         setEmailError(err.message);
         break;
        case "auth/wrong-password":
         setPasswordError(err.message);
         break;
        default:
          break;
      }
    });
  };

  const handleSignup = () =>{
    clearErrors();
    alert('We are currently not accepting online registration. To register, please contact our LPAS team lpasintakes@nasboces.org to request a login.\n'+
    'If you already have a login, please click on Sign In and enter your username and password.');
    /*
    fire
    .auth()
    .createUserWithEmailAndPassword(email, password)
    .catch(err => {
      switch(err.code){
        case "auth/email-already-in-use":
        case "auth/invalid-email":
            setEmailError(err.message);
            break;
            case "auth/weak-password":
              setPasswordError(err.message);
              break;
      }
    });
    */
  };

  const handleLogout = () =>{
    fire.auth().signOut();
  };

  const sendResetPwEmail = () =>{
    fire.auth().sendPasswordResetEmail(resetPwEmail).then(function() {
        // Email sent.
        alert("You should receive an email within the next few minutes.")
        window.location.reload();
      }).catch(function(error) {
        // An error happened.
        alert(error)
      });
}

  const authListener = () =>{
    fire.auth().onAuthStateChanged( user =>{
      if (user){
        clearInputs();
        setUser(user);
      } else{
        setUser("");
      }
    });
  };

  useEffect(() => {
    //authListener();
  },);// []);

  return (
    <div className="App">

    {/*}
      {user ? (
        <Intake uid={uid} handleLogout={handleLogout} />
      ) : (
        <Login 
      email={email} 
      setEmail={setEmail} 
      password={password} 
      setPassword={setPassword} 
      handleLogin={handleLogin} 
      handleSignup={handleSignup} 
      hasAccount={hasAccount}
      setHasAccount={setHasAccount}
      emailError={emailError}
      passwordError={passwordError}
      setResetPwEmail={setResetPwEmail}
      sendResetPwEmail={sendResetPwEmail}
      />
      )}   */}
      <Provider store={store}>
        <Intake uid={uid} handleLogout={handleLogout} />
      </Provider>
      
      
    </div>
  )
}

export default App;
